var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dsa-loading",class:{ compact: _vm.compact }},[_c('div',{staticClass:"dsa-spinner",attrs:{"aria-hidden":"true"}}),(_vm.text !== false)?_c('p',[_vm._v(_vm._s(_vm.displayText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }